const getErrorMessage = (err) => {
    if (!err) {
        return;
    }
    if (Object.getOwnPropertyDescriptor(err, 'message')) {
        return err.message;
    }
    return String(err);
};

export { getErrorMessage as g };
//# sourceMappingURL=getErrorMessage-f1ecd956.js.map
